import type { CatalogPropertyPreviewSummary } from 'src/api/generated';
import { formatPropertyCode } from 'src/modules/shared/utils/catalog/property-code.util';
import { buildCatalogPropertyTextViewModel } from 'src/modules/shared/utils/catalog/property-summary.util';
import type {
  ConversationCardTranslate,
  ConversationPropertySummaryViewModel,
} from '../types/conversation-property-summary.type';

/** Adds the conversation card's name and identifier to the shared property text presentation. */
export const buildConversationPropertySummaryViewModel = (
  property: CatalogPropertyPreviewSummary,
  propertyId: number,
  t: ConversationCardTranslate
): ConversationPropertySummaryViewModel => {
  const text = buildCatalogPropertyTextViewModel(property, t);
  const codeValue = formatPropertyCode({
    displayCode: property.displayCode,
    fallback: `#${propertyId}`,
  });
  return {
    ...text,
    name: property.name.trim() ? property.name : text.displayTitle,
    codeValue,
    code: t('communications.conversationCard.property.code', { id: codeValue }),
  };
};
